import { useEffect } from 'react'

const CLIENT_ID = '654998624684-rr7e6n8goj4627da512lpe4fllhsv6a6.apps.googleusercontent.com'

const REDIRECT_URI = "https://flowapp.nuraml.com/redirect"

const useGoogleOAuth = () => {
    useEffect(() => {
        const script = document.createElement('script')
        script.src = 'https://accounts.google.com/gsi/client'
        script.onload = initializeGoogleSignIn
        script.async = true
        script.defer = true
        document.head.appendChild(script)
    }, [])

    const initializeGoogleSignIn = () => {
        window.google.accounts.id.initialize({
            client_id: CLIENT_ID,
            ux_mode: 'redirect',
            redirect_uri: REDIRECT_URI
        })
        window.google.accounts.id.renderButton(document.getElementById("g-icon"), {
            theme: 'outline',
            size: 'large',
            type: "icon",
        })
    }

    const signInWithGoogle = () => {
        const clientId = CLIENT_ID
        const redirectUri = REDIRECT_URI
        const responseType = 'code'
        const scope = 'email profile'

        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&scope=${encodeURIComponent(scope)}&prompt=select_account`

        window.location.href = authUrl
    }

    return {
        signIn: signInWithGoogle,
    }
}

export default useGoogleOAuth